export type ProductTypeOptions =
  | 'buckle'
  | 'strap'
  | 'gift'
  | 'strap-pack'
  | 'tool'
  | 'warranty'
  | 'colorado-tax-dummy'
  | 'watch'
  | 'eyewear'
  | 'digital-item';

export type TranslatedProductType = Extract<
  ProductTypeOptions,
  | 'watch'
  | 'strap'
  | 'buckle'
  | 'tool'
  | 'warranty'
  | 'eyewear'
  | 'digital-item'
>;

export const enum ProductTypeEnum {
  Buckle = 'buckle',
  Strap = 'strap',
  Gift = 'gift',
  StrapPack = 'strap-pack',
  Tool = 'tool',
  Warranty = 'warranty',
  ColoradoTaxDummy = 'colorado-tax-dummy',
  Watch = 'watch',
  Eyewear = 'eyewear',
  DigitalItem = 'digital-item',
}
